<template>
    <div>
        <loader :loading="isLoading" v-if="isLoading"></loader>
        <ForecastTable>
            <template slot="head-row-0">
                <th colspan="5" class="items-included-text">
                    <span class="count">{{ items.length }}</span
                    >Items included in the forecast
                </th>
            </template>
            <template slot="head-row-2">
                <th></th>
                <th>Item</th>
                <th>Description</th>
                <th>Total QTY</th>
                <th>Markets with prices</th>
                <th></th>
            </template>
            <template slot="body">
                <tbody>
                    <tr v-for="(item, index) in items" v-bind:key="item.id" :class="{ isDisabled: isItemDisabled(item) }">
                        <td :style="item.color != null && item.color !== '' ? 'border-left: 15px solid ' + item.color : ''">{{ index + 1 }}</td>
                        <td><ItemImage class="item-image" :item="item" /></td>
                        <td><ItemDescription :item="item" :forecast="forecast" /></td>
                        <td>{{ getQuantities(item) }}</td>
                        <td><AllPricesInfo :item="item" :forecast-windows="forecastWindows" /></td>
                        <td><ItemQuantitiesButton :item="item" :forecast="forecast" /></td>
                    </tr>
                </tbody>
            </template>
        </ForecastTable>
    </div>
</template>
<script>
import ItemValidator from "@/components/forecasts/validation/itemValidator";
import ItemImage from "@/components/forecasts/elements/ItemImage";
import ForecastTable from "@/components/forecasts/elements/table/ForecastTable";
import ItemDescription from "@/components/forecasts/elements/ItemDescription";
import forecastsService from "@/components/forecasts/forecastsService";
import loader from "@/components/loader/loader";
import ItemQuantitiesButton from "@/components/forecasts/elements/table/ItemQuantitiesButton";
import AllPricesInfo from "@/components/forecasts/elements/AllPricesInfo";
import { getQuantitiesForForecastWindows } from "@/components/forecasts/utils/utilis";

export default {
    components: {
        ItemQuantitiesButton,
        ForecastTable,
        ItemDescription,
        ItemImage,
        loader,
        AllPricesInfo
    },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindows: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            items: []
        };
    },
    async created() {
        this.items = await forecastsService.getItems(this.forecast.id, true);
        this.isLoading = false;
    },
    methods: {
        isItemDisabled(item) {
            return ItemValidator.isDisabled(item);
        },
        getQuantities(item) {
            return getQuantitiesForForecastWindows(item.id, this.forecastWindows);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts";
tr.isDisabled {
    background-color: $color_background_disabled;
}
</style>



// WEBPACK FOOTER //
// ItemList.vue?23192e90